import { render } from "./ListEvalPatient.vue?vue&type=template&id=00c61f4f&scoped=true&ts=true"
import script from "./ListEvalPatient.vue?vue&type=script&lang=ts"
export * from "./ListEvalPatient.vue?vue&type=script&lang=ts"

import "./ListEvalPatient.vue?vue&type=style&index=0&id=00c61f4f&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/BV_HV/DanhGia_FE_HV/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c61f4f"]])

export default __exports__